var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Actions, Effect } from '@ngrx/effects';
import { ROUTER_NAVIGATION } from '@ngrx/router-store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { InvestorHelperHideAction } from 'shared/store/layout.reducers';
var LayoutEffects = /** @class */ (function () {
    function LayoutEffects(actions$) {
        this.actions$ = actions$;
        this.hideInvestorHelperOnRouteChange$ = this.actions$.ofType(ROUTER_NAVIGATION).pipe(map(function (_) { return new InvestorHelperHideAction(); }));
    }
    __decorate([
        Effect(),
        __metadata("design:type", Observable)
    ], LayoutEffects.prototype, "hideInvestorHelperOnRouteChange$", void 0);
    return LayoutEffects;
}());
export { LayoutEffects };
